import PropTypes from "prop-types"
import Tooltip from "components/material/tooltip"
import { IconButton } from "@mui/material"
import { AccountBalanceWallet } from "@mui/icons-material"
import { formatLabel } from "helpers/securities"
import ResearchTopicCreate from "modules/research-topic-create"
import { Creators as TopicCreators } from "modules/research-topic-create/model"
import { Creators as ProfileCreators } from "model/profileModal"
import { Creators as DialogCreators } from "modules/dialog/model"
import { MODEL, SECURITY } from "helpers/shapes"
import { formatShortDate } from "helpers/formatters/dates"

export default function SecurityProfileToResearchTopic({ dispatch, account, security, modelId, setModel, models, selectedDate }) {
  const { assetClass } = security ?? {}
  const label = formatLabel(security)

  const canCreateResearchTopic = assetClass === "equity"

  const openResearchTopicCreation = () => {
    if (!canCreateResearchTopic) { return }
    dispatch(ProfileCreators.closeSecurityProfile())
    dispatch(DialogCreators.open({
      content: <ResearchTopicCreate
        setResearchTopicModel={setModel}
        {...{
          account,
          modelId,
          models,
          defaultName: `${label} - Smart Trade ${formatShortDate(selectedDate)}`,
          defaultDescription: `Research various hedging instruments for ${label} on ${formatShortDate(selectedDate)}`,
        }}
      />,
    }))

    // [security, portfolio] are the only supported types and you can't see a portfolio in the security profile
    dispatch(TopicCreators.setInstrument({ ...security, type: "security" }))
    dispatch(TopicCreators.setSelectedDate(selectedDate))
  }

  const tooltip = canCreateResearchTopic ? `Create research topic for ${label}` : `Research topic creation is not supported for ${label}`

  return <Tooltip title={tooltip}>
    <span>
      <IconButton
        onClick={openResearchTopicCreation}
        disabled={!canCreateResearchTopic}
        size="large"
      >
        <AccountBalanceWallet />
      </IconButton>
    </span>
  </Tooltip>
}

SecurityProfileToResearchTopic.propTypes = {
  dispatch: PropTypes.func.isRequired,
  account: PropTypes.string.isRequired,
  security: SECURITY.isRequired,
  modelId: PropTypes.string.isRequired,
  setModel: PropTypes.func,
  selectedDate: PropTypes.string.isRequired,
  models: PropTypes.oneOfType([PropTypes.arrayOf(MODEL), PropTypes.objectOf(MODEL)]),
}
